<template>
    <div class="ui-content dashboard">
        <v-card class="mx-auto normal-card autohg">
            <div class="negative-marking-impact">
                <div class="accordian-block">
                    <v-expansion-panels>
                        <v-expansion-panel v-if="!ishide">
                            <v-expansion-panel-header>
                                <div class="expansion-title">Time Machine &copy;</div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <TimeMachine :studentId="studentId"  :studentTestId="studentTestId" />
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                <div class="expansion-title">Details of Attempts & Time</div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <DetailsAttemptsTime :studentId="studentId" :studentTestId="studentTestId" />
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import TimeMachine from "@/components/student/TimeMachine.vue";
import DetailsAttemptsTime from "@/components/student/DetailsAttemptsTime.vue";
export default {
    name: "TimeAnalysis",
    components: {
        TimeMachine,
        DetailsAttemptsTime
    },
    mounted() {
        this.studentId = this.$route.params.student_id;
        this.testId = this.$route.params.test_id;
        this.studentTestId = this.$route.params.student_test_id;  
        if (this.$route && this.$route.params && this.$route.params.hide) {
            this.ishide=this.$route.params.hide;
        }
        this.getOmrDetails()
    },

    data() {
        return {
            studentId: null,
            testId: null,
            studentTestId: null,
            ishide:false,
        };
    },
    methods:{
        ...mapActions({
            getOmrDetail: "testStore/getOmrDetail",
        }),
        getOmrDetails(){
            const {test_id, student_id} = this.$route.params
            const reqData = {
                test_id,
                student_id
            }

            this.getOmrDetail(reqData)
            .then(response=>{
                this.ishide =  response ? true:false
            })
            .catch(err=>{

            })
        }

    }
};
</script>